const countyCodes = new Map<string, number>([
    ['Alamance', 1],
    ['Alexander', 2],
    ['Alleghany', 3],
    ['Anson', 4],
    ['Ashe', 5],
    ['Avery', 6],
    ['Beaufort', 7],
    ['Bertie', 8],
    ['Bladen', 9],
    ['Brunswick', 10],
    ['Buncombe', 11],
    ['Burke', 12],
    ['Cabarrus', 13],
    ['Caldwell', 14],
    ['Camden', 15],
    ['Carteret', 16],
    ['Caswell', 17],
    ['Catawba', 18],
    ['Chatham', 19],
    ['Cherokee', 20],
    ['Chowan', 21],
    ['Clay', 22],
    ['Cleveland', 23],
    ['Columbus', 24],
    ['Craven', 25],
    ['Cumberland', 26],
    ['Currituck', 27],
    ['Dare', 28],
    ['Davidson', 29],
    ['Davie', 30],
    ['Duplin', 31],
    ['Durham', 32],
    ['Edgecombe', 33],
    ['Forsyth', 34],
    ['Franklin', 35],
    ['Gaston', 36],
    ['Gates', 37],
    ['Graham', 38],
    ['Granville', 39],
    ['Greene', 40],
    ['Guilford', 41],
    ['Halifax', 42],
    ['Harnett', 43],
    ['Haywood', 44],
    ['Henderson', 45],
    ['Hertford', 46],
    ['Hoke', 47],
    ['Hyde', 48],
    ['Iredell', 49],
    ['Jackson', 50],
    ['Johnston', 51],
    ['Jones', 52],
    ['Lee', 53],
    ['Lenoir', 54],
    ['Lincoln', 55],
    ['Macon', 56],
    ['Madison', 57],
    ['Martin', 58],
    ['Mcdowell', 59],
    ['Mecklenburg', 60],
    ['Mitchell', 61],
    ['Montgomery', 62],
    ['Moore', 63],
    ['Nash', 64],
    ['New Hanover', 65],
    ['Northampton', 66],
    ['Onslow', 67],
    ['Orange', 68],
    ['Pamlico', 69],
    ['Pasquotank', 70],
    ['Pender', 71],
    ['Perquimans', 72],
    ['Person', 73],
    ['Pitt', 74],
    ['Polk', 75],
    ['Randolph', 76],
    ['Richmond', 77],
    ['Robeson', 78],
    ['Rockingham', 79],
    ['Rowan', 80],
    ['Rutherford', 81],
    ['Sampson', 82],
    ['Scotland', 83],
    ['Stanly', 84],
    ['Stokes', 85],
    ['Surry', 86],
    ['Swain', 87],
    ['Transylvania', 88],
    ['Tyrrell', 89],
    ['Union', 90],
    ['Vance', 91],
    ['Wake', 92],
    ['Warren', 93],
    ['Washington', 94],
    ['Watauga', 95],
    ['Wayne', 96],
    ['Wilkes', 97],
    ['Wilson', 98],
    ['Yadkin', 99],
    ['Yancey', 100],
]);

export function getCountyCode(county: string) {
    const name = county?.trim().toLowerCase();
    for (const [key, code] of countyCodes) {
        if (key.toLowerCase() === name) return code;
    }
    return null;
}
